import Vue from 'vue'

import DefaultImage from './components/default-image/DefaultImage'
import appointmentItem from './components/appointment/appointmentItem'
import consultationItem from './components/consultation/consultationItem'
import prescriptionItem from './components/prescription/prescriptionItem.vue'
import drugItem from './components/drug/drugItem'
import doctorList from './components/doctor/doctorList'
import LoadMore from './components/load-more/LoadMore'
import tabs from './components/tabs/tabs'
import orderItem from './components/order/orderItem'
import patientSelect from './components/patient/patientSelect.vue'
import patientAllSelect from './components/patient/patientAllSelect.vue'
import AddressItem from './components/category/addressItem'
import priceTable from './components/priceTable/priceTable'

const components = [
  DefaultImage,
  appointmentItem,
  consultationItem,
  prescriptionItem,
  drugItem,
  doctorList,
  LoadMore,
  tabs,
  orderItem,
  patientSelect,
  patientAllSelect,
  AddressItem,
  priceTable
]
components.map(component => {
  Vue.component(component.name, component)
})
